import PageHeader from "components/general/Headers/PageHeader";
import Seo from "components/general/Seo";
import { Box } from "components/ui/box";
import { useGlobalSearchParams } from "expo-router";
import React from "react";
import { ActivityIndicator } from "react-native";
import ItemListing from "screens/ItemListing";
import { useGetCategoryByCategorySlugAndSubCategorySlugQuery, useGetCategoryBySlugQuery } from "store/abcoApi";
import { useIsMobile } from "utils/hooks/useIsMobile";
export default function Page() {
	const [filterValues, setFilterValues] = React.useState({} as any);
	const { subcategory: slug, category: categorySlug } = useGlobalSearchParams();
	const { data: topCategory }: any = useGetCategoryBySlugQuery({ slug: String(categorySlug) }, { skip: !slug });
	const [isGridView, setIsGridView] = React.useState(true);
	const isMobile = useIsMobile();
	const {
		data: category,
		isLoading,
		isFetching,
		isError,
		error,
		currentData,
	}: { data?: any; isLoading: boolean; isFetching: boolean; isError: boolean; error?: any; currentData?: any } = useGetCategoryByCategorySlugAndSubCategorySlugQuery(
		{
			categorySlug: String(categorySlug),
			subCategorySlug: String(slug),
			sortBy: filterValues?.sortBy,
			isCore: filterValues?.isCore,
			inStock: filterValues?.inStock,
			isApprovedItem: filterValues?.isApprovedItem,
		},
		{ skip: !slug },
	);

	function handleFilterChange(value: any) {
		setFilterValues((prevValues: any) => ({
			...prevValues,
			...value,
		}));
	}

	// console.log("handleFilterChange", filterValues);

	//const { data:category, isLoading, isFetching, isError, error, currentData} = useGetCategoryBySlugQuery({slug: String(slug)});

	if (isFetching && isLoading) {
		return (
			<Box height={"$full"} justifyContent="center" alignItems="center" bg="transparent">
				<Box flex={1} justifyContent="center">
					<ActivityIndicator size="large" style={{ transform: [{ scaleX: 2 }, { scaleY: 2 }] }} />
				</Box>
			</Box>
		);
	}

	if (category == null) {
		return;
	}

	return (
		<>
			<Seo title={category?.seoTitle} description={category?.seoDescription} />
			<ItemListing topCategory={topCategory} category={category} handleFilterChange={handleFilterChange} itemCollection={category.itemCollection} totalFoundItems={category.itemCollection.length} isFetchingItems={isFetching}>
				<PageHeader title={category?.name} />
			</ItemListing>
		</>
	);
}
